export default __webpack_public_path__ + "static/media/coverAbout.638ed129.jpg";